import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { VerificationStatusType } from "../../Types/General";

interface WebsocketState {
    verification_status: VerificationStatusType | null;
}

const initialState: WebsocketState = {
    verification_status: null,
}

export const websocketSlice = createSlice({
    name: 'Websocket',
    initialState,
    reducers: {
        resetWebsocketSlice: () => initialState,
        setVerificationStatus(state, action: PayloadAction<WebsocketState["verification_status"]>){
            state.verification_status = action.payload;
        },
    }
})

export const {
    resetWebsocketSlice,
    setVerificationStatus
} = websocketSlice.actions

export default websocketSlice.reducer

